import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";

const FALLBACK = {
  overline: "About Royale Yaan",
  hero_title: "A house built on the love of extraordinary machines.",
  hero_emphasis: "extraordinary machines.",
  story_overline: "Our Story",
  story_heading: "Curated for the connoisseur.",
  story_paragraphs: [],
  values: [],
  cta_heading: "Begin a conversation.",
};

function renderHero(title, emphasis) {
  if (!emphasis || !title.includes(emphasis)) return title;
  const [before, ...rest] = title.split(emphasis);
  const after = rest.join(emphasis);
  return (
    <>
      {before}
      <em className="not-italic gold-accent">{emphasis}</em>
      {after}
    </>
  );
}

export default function About() {
  const [c, setC] = useState(FALLBACK);

  useEffect(() => {
    api.get("/content/about").then((r) => setC(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="about-page">
      <section className="bg-white border-b border-gray-100">
        <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-16 py-20 md:py-28">
          <p className="overline mb-4">{c.overline}</p>
          <h1 className="font-display text-5xl md:text-6xl lg:text-7xl tracking-tighter font-light max-w-5xl">
            {renderHero(c.hero_title, c.hero_emphasis)}
          </h1>
        </div>
      </section>

      <section className="bg-[#FCFCFC] py-24">
        <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-16 grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <p className="overline mb-3">{c.story_overline}</p>
            <h2 className="font-display text-3xl md:text-4xl tracking-tighter font-light">{c.story_heading}</h2>
          </div>
          <div className="md:col-span-7 space-y-6 text-gray-700 leading-relaxed">
            {(c.story_paragraphs || []).map((p, i) => (
              <p key={i}>{p}</p>
            ))}
          </div>
        </div>
      </section>

      {(c.values || []).length > 0 && (
        <section className="bg-white border-y border-gray-100 py-20">
          <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-16 grid grid-cols-2 md:grid-cols-4 gap-10">
            {c.values.map((v, i) => (
              <div key={i}>
                <p className="font-display text-4xl md:text-5xl tracking-tighter font-light">{v.n}</p>
                <p className="overline mt-3">{v.l}</p>
              </div>
            ))}
          </div>
        </section>
      )}

      <section className="bg-black text-white py-24">
        <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-16 flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
          <h2 className="font-display text-4xl md:text-5xl tracking-tighter font-light">{c.cta_heading}</h2>
          <div className="flex flex-wrap gap-3">
            <Link to="/inventory" className="px-7 py-4 text-sm tracking-wide bg-white text-black rounded-sm hover:bg-gray-100">Browse inventory</Link>
            <Link to="/contact" className="px-7 py-4 text-sm tracking-wide border border-white/30 rounded-sm hover:bg-white/10">Contact us</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
